var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('p',{staticClass:"font-italic fontSize"},[_vm._v(" "+_vm._s(_vm.$t("components.basicHistory.createAt"))+" "+_vm._s(_vm._f("moment")(_vm.value.createAt ? _vm.value.createAt : ""))+" "+_vm._s(_vm.$t("components.basicHistory.createBy"))+" "+_vm._s(_vm.value.createBy ? _vm.value.createBy : "")+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }